import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CartComponent } from './cart.component';
import { CardPaymentFailureComponent } from './components/card-payment-failure/card-payment-failure.component';
import { CardPaymentSuccessComponent } from './components/card-payment-success/card-payment-success.component';
import { MobilePaymentComponent } from './components/mobile-payment/mobile-payment.component';
import { OrderConfirmationComponent } from './components/order-confirmation/order-confirmation.component';
import { OrderSummaryComponent } from './components/order-summary/order-summary.component';
import { PaymentFailureComponent } from './components/payment-failure/payment-failure.component';
import { PaymentSuccessComponent } from './components/payment-success/payment-success.component';
import { PaymentComponent } from './components/payment/payment.component';
import { ReviewComponent } from './components/review/review.component';

const routes: Routes = [
  {
    path: '', component: CartComponent,
  },
  {
    path: 'order-confirmation', component: OrderConfirmationComponent
  },
  {
    path: 'payment', component: PaymentComponent,
  },
  {
    path: 'payment/success', component: PaymentSuccessComponent,
  },
  {
    path: 'payment/failure', component: PaymentFailureComponent,
  },
  {
    path: 'mobile/payment', component: MobilePaymentComponent,
  },
  {
    path: 'payment/card-payment/success', component: CardPaymentSuccessComponent,
  },
  {
    path: 'payment/card-payment/failure', component: CardPaymentFailureComponent,
  },
  {
    path: 'review', component: ReviewComponent,
  },
  {
    path: 'order-summary', component: OrderSummaryComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CartRoutingModule { }
